/* eslint-disable import/prefer-default-export */
import gql from 'graphql-tag';

export const GET_WEPLOYEE_PROFILE_SUMMARIES = gql`
  query profileSummarySearchQuery($searchTerm: String!, $filter: FilterInputObject!, $first: Int, $after: Int) {
    weployer {
      weployeeProfileSummaries(searchTerm: $searchTerm, filter: $filter, first: $first, after: $after) {
        total
        summaries {
          summary
        }
      }
    }
  }
`;
